import type React from "react";
import styles from "./index.module.scss";

export interface StepperStep {
  id: number;
  label: string;
}

interface StepperProps {
  steps: StepperStep[];
  currentStep: number;
  className?: string;
}

const Stepper: React.FC<StepperProps> = ({ steps, currentStep, className }) => {
  return (
    <div className={`${styles["stepper"]} ${className || ""}`}>
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === currentStep;
        const isDone = stepNumber < currentStep;

        return (
          <div
            key={step.id}
            className={`${styles["stepItem"]} ${isActive ? styles["active"] : ""} ${isDone ? styles["done"] : ""}`}
          >
            <div className={styles["stepNumber"]}>
              <span>{stepNumber}</span>
            </div>
            <div className={styles["stepContent"]}>
              <span className={styles["stepLabel"]}>{step["label"]}</span>
              {index < steps.length - 1 && <div className={styles["stepLine"]} />}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
